import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

const CompetitorsContainerBaseStyles = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 244px;
    background-color: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    padding: 12px;
    border-radius: 6px;
`;

export const StyledCompetitorsContainer = styled(CompetitorsContainerBaseStyles)<{ disabled: boolean }>`
    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${colorsPalettes.bluegrey[200]};
            cursor: not-allowed;
        `}
`;

export const StyledCompetitorsLoaderSkeleton = styled(CompetitorsContainerBaseStyles)`
    height: 254px;
    align-items: center;
    justify-content: center;
`;
